<div class="options" [formGroup]="formGroup">
  <div class="option" *ngFor="let option of options">
    <input type="radio" id="{{field.name}}-{{option.id}}" [value]="option" [formControlName]="field.name" />
    <label for="{{field.name}}-{{option.id}}">{{option.caption || option.title || option.name}}</label>
  </div>
</div>
